module.exports = __webpack_public_path__ + "static/media/20ECE1.297cc45b.jpg";